<template>
  <div :class="{ active: gaming.hasBonusActive }" class="gaming-progess-bonus">
    <div class="background"></div>
    <div class="progress" :class="{ animate: animate }" :style="style"></div>
  </div>
</template>
<script setup lang="ts">
const gaming = useGamingStore();
const style = ref({});
const animate = ref<boolean>(false);
const computeStyle = (progress) => {
  style.value = {
    transform: `scaleX(${gaming.activeBonusProgress})`,
  };
};

watch(
  () => gaming.activeBonusProgress,
  (progress) => {
    requestAnimationFrame(() => {
      computeStyle(progress);
    });
  }
);

computeStyle(gaming.activeBonusProgress);

onMounted(() => {
  requestAnimationFrame(() => (animate.value = true));
});
</script>
<style lang="scss" scoped>
.gaming-progess-bonus {
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.4rem;
  overflow: hidden;
}
.background,
.progress {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform-origin: 0%;
}
.background {
  transition: background-color 500ms $ease-out-quad;
  background-color: var(--color_neutral_25);
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 0.1rem;
    background-color: var(--color_secondary_light);
  }
}
.progress {
  background-color: var(--color_secondary);
  will-change: transform;
  &.animate {
    transition: transform 200ms $ease-out-quad;
  }
}
.active {
  .background {
    background-color: var(--color_secondary_light);
  }
}
</style>
